import { useState } from "react";
import { Loader2 } from "lucide-react";
import API_BASE_URL from "../config";

const NOTES = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B",
];

export default function ScaleChanger({ file, result }) {

    const [targetScale, setTargetScale] = useState(result.sa);

    const [loading, setLoading] = useState(false);

    const [audioUrl, setAudioUrl] = useState(null);

    const [downloadUrl, setDownloadUrl] = useState(null);

    const generateTrack = async () => {

        if (!file) {
            alert("Please upload a song first.");
            return;
        }

        const currentIndex = result.scale_index;

        const targetIndex = NOTES.indexOf(targetScale);

        let shift = targetIndex - currentIndex;

        // choose shortest musical distance
        if (shift > 6) shift -= 12;

        if (shift < -6) shift += 12;

        console.log("Current:", result.sa);

        console.log("Target:", targetScale);

        console.log("Shift:", shift);

        const formData = new FormData();

        formData.append("file", file);

        setLoading(true);

        try {

            const response = await fetch(

                `${API_BASE_URL}/api/change-scale?shift=${shift}`,

                {
                    method: "POST",
                    body: formData,
                }

            );

            if (!response.ok) {

                throw new Error("Unable to generate track.");

            }

            const blob = await response.blob();

            const url = URL.createObjectURL(blob);

            setAudioUrl(url);

            setDownloadUrl(url);

        }

        catch (err) {

            console.error(err);

            alert("Scale generation failed.");

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div className="mt-10 rounded-2xl border border-border bg-card p-8">

            <h2 className="text-3xl font-bold mb-8">

                🎼 Scale Changer

            </h2>

            <div className="grid md:grid-cols-2 gap-6">

                <div className="rounded-xl bg-secondary p-5">

                    <div className="text-sm text-muted-foreground">

                        Current Scale

                    </div>

                    <div className="text-4xl font-bold mt-3">

                        {result.sa}

                    </div>

                </div>

                <div className="rounded-xl bg-secondary p-5">

                    <div className="text-sm text-muted-foreground mb-3">

                        Change To

                    </div>

                    <select

                        value={targetScale}

                        onChange={(e) => setTargetScale(e.target.value)}

                        className="w-full rounded-lg bg-card border border-border p-3"

                    >

                        {NOTES.map((note) => (

                            <option
                                key={note}
                                value={note}
                            >

                                {note}

                            </option>

                        ))}

                    </select>

                </div>

            </div>

   <div className="mt-8 text-center">

    <button

        onClick={generateTrack}

        disabled={loading}

        className="bg-primary text-primary-foreground px-8 py-3 rounded-lg font-semibold hover:opacity-90 disabled:opacity-50"

    >

        {loading ?

            <span className="flex items-center justify-center gap-2">

                <Loader2
                    size={18}
                    className="animate-spin"
                />

                Generating New Scale...

            </span>

            :

            "🎼 Generate New Track"

        }

    </button>

</div>

{audioUrl && (

    <div className="mt-10 border-t border-border pt-8">

        <h3 className="text-2xl font-bold mb-6">

            ✅ New Scale Generated

        </h3>

        <audio

            controls

            src={audioUrl}

            className="w-full"

        />

        <div className="mt-6 flex justify-center">

            <a

                href={downloadUrl}

                download={`scaled-${targetScale}.mp3`}

                className="bg-primary text-primary-foreground px-8 py-3 rounded-lg font-semibold"

            >

                ⬇ Download Track

            </a>

        </div>

    </div>

)}

        </div>

    );

}